import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M11 0v7h7a7 7 0 0 0-7-7zm1.2 1.325A5.817 5.817 0 0 1 16.675 5.8H12.2V1.325zM9 2H8a8 8 0 1 0 8 8V9H9V2zm-7.8 8c0-3.682 2.943-6.683 6.6-6.79v6.341l-4.915 4.915A6.762 6.762 0 0 1 1.2 10zM8 16.8a6.762 6.762 0 0 1-4.251-1.501L8 11.049l4.251 4.25A6.762 6.762 0 0 1 8 16.8zm6.79-6.6a6.76 6.76 0 0 1-1.675 4.266L8.849 10.2h5.941z" />
  </svg>
);

export default SvgComponent;
